<template>
  <site-banner pagina="tratamentos" />

  <site-tratamentos />

  <site-pesquisa />
</template>

<script setup>
const { t, locale } = useI18n();

useSeoMeta({
  title: t("Tratamentos e Clínico Geral da ") + t("sorrifacil"),
  ogTitle: t("Tratamentos e Clínico Geral da ") + t("sorrifacil"),
  description: t("sorrifacil") + t(" especializada em implantes e ortodontia"),
  ogDescription:
    t("sorrifacil") + t(" especializada em implantes e ortodontia"),
});
</script>

<script>
export default {
  name: "TratamentosPagina",
};
defineI18nRoute({
  paths: {
    pt: "/tratamentos",
    es: "/tratamientos",
  },
});
</script>
